export default {
  mode: "lazy",
  source: "marketing-event-attendance-cards-ui/lang",
  context: {
    "en": function () { return import("!/usr/share/hubspot/build/.bpm/packages/bender-build-tools/static-1.2186/node_modules/bender-lyaml-loader/lib/postmodern.js!./en.lyaml?sporks" /* webpackChunkName: "marketing-event-attendance-cards-ui-lang-en" */); }  }
};
